import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../modules';
import { editContent } from "../../modules/editor";
import { DragDropContext, Draggable, Droppable, DropResult, DroppableStateSnapshot, DraggableProvided, DraggableStateSnapshot, DroppableProvided } from 'react-beautiful-dnd';

import produce from 'immer';

import { mapOrder } from '../../util/array';

import check from '../../assets/images/icon/check.png';
import checked from '../../assets/images/icon/checked.png';
import dragHandle from '../../assets/images/icon/dragHandle.png';

type Props = {
	isCnt: boolean;
}

function SelectedContentLayout({ isCnt }: Props) {
	const [itemsOrigin, setItemsOrigin] = useState([
		{ id: 0, label: '이미지', value: 'image', active: false },
		{ id: 1, label: '텍스트', value: 'text', active: false },
		{ id: 2, label: '버튼', value: 'cta', active: false },
	] as any);
	const [items, setItems] = useState([] as any);

	const dispatch = useDispatch();

	const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);
	const contents = useSelector((state: RootState) => state.editor.contents);

	const currentContent = contents?.find((item) => {
		return item.id === selectedContentId;
	}); 

	const targetIndex = isCnt ? currentContent?.content?.column.findIndex((item:any) => !item.includes('image')) : 0;

	useEffect(() => {
		const orderOrigin = itemsOrigin.map((item: any) => {
			return item.value;
		})
		let order = Array.from(currentContent?.content?.column[targetIndex] || []);
		orderOrigin.map((item:string) => {
			if (!order.includes(item)) {
				order.push(item);
			}
		})

		// cntB 분기
		if (isCnt) {
			setItems(mapOrder(itemsOrigin, order, 'value').filter((item:any) => item.value !== 'image'));
		} else {
			setItems(mapOrder(itemsOrigin, order, 'value'));
		}
		
	}, [selectedContentId]);

	const onToggleColumnItem = (item:any, currentIndex:number) => {		
		
		let newValue:any = produce(currentContent?.content?.column, (draft:any) => {
			if (isCnt) {
				if (draft[targetIndex].includes(item.value)) {
					draft[targetIndex].splice(draft[targetIndex].indexOf(item.value), 1);
				} else {
					draft[targetIndex].splice(currentIndex, 0, item.value);
				}
			} else {
				draft.map((columnItem:string[]) => {				
					if (columnItem.includes(item.value)) {
						columnItem.splice(columnItem.indexOf(item.value), 1);
					} else {
						columnItem.splice(currentIndex, 0, item.value);
					}
				})
			}
		});

		if (newValue.length === 2) {
			if (newValue[0].length === 0 || newValue[1].length === 0) { 
				return;
			}
		} else {
			if (newValue[0].length === 0) { 
				return;
			}
		}

		dispatch(editContent({ target: `${selectedContentId}/column`, data: newValue }));
	}


	const moveEnd = (items:any) => {
		let n:any = produce(items, (draft:any) => {
			return draft.map((item:any) => {
				return item.value;
			});
		})
		let m:any = n.filter((item:string) => {
			return currentContent?.content?.column[targetIndex].includes(item);
		})
		// TODO: 리팩
		let v:any = [];
		if (currentContent?.content?.column.length === 1) {
			v = [m];
		} else {
			v = [m, m];
		}

		if (isCnt) {
			v = JSON.parse(JSON.stringify(currentContent?.content?.column));
			v[targetIndex] = m;
		}

		dispatch(editContent({ target: `${selectedContentId}/column`, data: v }));
	}

	const reOrder = (list: any, startIndex: any, endIndex: any) => {
		const result = Array.from(list);
		const [removed] = result.splice(startIndex, 1);
		result.splice(endIndex, 0, removed);

		setItems(result);
		moveEnd(result);
	};

	const onDragEnd = (result: any) => {
		// dropped outside the list(리스트 밖으로 드랍한 경우)
		if (!result.destination) {
			return;
		}

		reOrder(
			items,
			result.source.index,
			result.destination.index
		);
	}

	const getItemStyle = (draggableStyle: any, isDragging: any) => ({
		// some basic styles to make the items look a bit nicer(아이템을 보기 좋게 만드는 몇 가지 기본 스타일)
		userSelect: 'none',
		// padding: grid * 2,
		// marginBottom: grid,
		// height: 100,

		// change background colour if dragging(드래깅시 배경색 변경)
		// background: isDragging ? 'lightgreen' : 'grey',
		boxShadow: isDragging ? '0 0 10px 0 rgba(0,0,0,.4)' : 'none',

		// styles we need to apply on draggables(드래그에 필요한 스타일 적용)
		...draggableStyle
	});

	return (
		<>
			<h3 className="field-section-title">구성 요소</h3>
			<div className="inner-content-sort">
				<DragDropContext
					onDragEnd={onDragEnd}
				>
					<Droppable droppableId="layoutsort">
						{(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => (
							<div
								{...provided.droppableProps}
								ref={provided.innerRef}
							>
								{items.map((item: any, index: number) => (
									<div key={item.id} >
										<Draggable
											index={index}
											key={item.id}
											draggableId={`${item.id}`}
										>
											{
												(provided, snapshot) => (
													<div 
														className="inner-content-sort-item"
														ref={provided.innerRef}
														{...provided.draggableProps}
														style={getItemStyle(
															provided.draggableProps.style,
															snapshot.isDragging
														)}
													>
														<div
															{...provided.dragHandleProps}
															className="drag-handle"
														>
															<img src={dragHandle} alt="dragHandle" width="6" />
														</div>

														<button 
															onClick={() => { onToggleColumnItem(item, index) }} className="toggle"
														>
															{
																currentContent?.content?.column[targetIndex]?.includes(item.value) ? (
																	<img src={checked} alt="check" width="22" />
																) : (
																	<img src={check} alt="check" width="22" />
																)
															}
															{item.label}
														</button>
													</div>
												)
											}
										</Draggable>
									</div>
								))}
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				</DragDropContext>
			</div>
		</>
	);
}

export default SelectedContentLayout;